import { ChangeDetectorRef, Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { EventViewModel } from '../../../models-views/event.view.model';
import { ActivatedRoute } from '@angular/router';
import { QuotationResponseModel } from '../../../models/event.model';
import { BehaviorSubject, debounceTime, Subject } from 'rxjs';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CompareQuotationsComponent } from '../compare-quotations/compare-quotations.component';
import { VendorResponseModel, VendorSubmissionResponseModel } from '../../../models/vendor.model';
import { CetVendorDetailsComponent } from '../cet-vendor-details/cet-vendor-details.component';
import { VendorSubmissionModalComponent } from '../../vendor-submission-modal/vendor-submission-modal.component';
import { AppCommon } from '../../../providers/app-common';
import { GenarateClientPptComponent } from '../genarate-client-ppt/genarate-client-ppt.component';

@Component({
  selector: 'app-cet-quotations',
  standalone: false,
  templateUrl: './cet-quotations.component.html',
  styleUrl: './cet-quotations.component.scss'
})
export class CetQuotationsComponent {

  @Input('eventId') eventId: string | null = null;
  @Input('eventData') eventData: any | null = null;
  quotationList = [];
  // vendorResponseModel = new BehaviorSubject<VendorResponseModel>(new VendorResponseModel());
  vendorSubmissionResponseModel = new BehaviorSubject<VendorSubmissionResponseModel>(
    new VendorSubmissionResponseModel()
  );
  @ViewChild('compareQuatationModalTitle') compareQuatationModalTitle!: TemplateRef<{}>;
  @ViewChild('getPPTModalModalTitle') getPPTModalModalTitle!: TemplateRef<{}>;
  loading: boolean = false
  checked: boolean = false
  setOfCheckedId: any = {}
  allChecked = false;
  indeterminate = false;
  compareQuatationModalRef: any;
  getClientPPTModalRef: any;

  rfqRef?: NzModalRef;
  sampleFallbackImage = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAEf0lEQVR4nO3ZS08bVxgG4GmVqlJUVaqo1G6qSpXabsJlZvBljmdsIlVVNl100UU3XXVfcmkAE2JIgnMBZmxsDzgXIvUHZEOatlEaG0gUAi2BVoBSRN2onjEGgw2lCQSHrzrjEOwJpjaML0h+pVfCu3l0znfOGBNEKaWUUvBIXno/LrGXE+RNn0k8CsgCCsqC8SsA4hViL0XijZQsMP2ygCC5koDuz3SYjESxJ+jSlck8cko8E1cjXmB4tC4J6LvwBd27RLEFvPRrEs98Iwkolg7w8uowy5LANP/hPPQ6UQwJ8sZPJJ4ZzxSwRadCDuaLwgEE9LHEM9/vApBaHt0KOZgDeQM8Etm3ZB6dkwW0qhlic7utyQLySu2Wt3MGABvxKj5CJQGFtQZs0Xk8c2Cz7NMUEepAB2UejeUBAKpOyh3GQ7sGBNu59/BRWQAApGw5HvXO8OwHWQPCbssbMs/YZYF5UmiELCD4u4OB4SZqLWtIzMNGC/3wMi6PYPyMHn46Vgm9teWQNQSu1sDTyxaIdJoKhpg6Z4Db9VUKYKM7gmz0yUUzhJ35Az1qZ+BuIwW9hzcBuD8erYhnDVnv2YTgrvdYYEnkIOTIHUASEIye0sGNwxUpgOu15dBXRw7daz3wTtaQf0WTceWi+a9kDG68xwJRD6c5YtKuh5vfJuYgub76KuhvoLLfUur808XB2mVLCgZ39ZIZ5jSYn+nzBvDXpc5Bb2053DxWCXcaKQWCu2vIUhcHuMvdZnjWowZZ4LHXDDMO046O0/snabiumoMbRypgwEqCvyEB0ByitJtTHjyunp+rNYBXLpTJHPDP5+BI6hzgwe63ktDXQKYAcgN53h+OVih7Wr3d1q5YYMHNpkU8PGuAW1vMwe26Khiwbm4jX/4g5XCnkYRJu05ZCTVo5ZIZZpOO60CbUdkuL89BYhttB/DlEoLP+ZGWavilmYZfm2kIXDAol6cahOdqqCnNHDRS4E+zjXz5guBGRRamzhsUCAY9aKlW5keNUd8H/vr0c+ArBGSjEbcJJux6BZM4EFjlaFZDfj6O5yB7gC9fkI3iWzn583I3B/ErFvxakQCojtOihSxt0UWRA3995a4AvmKA4GqB8JUgSSmtSJd2W8vfQOZnRhY8LATaDDmZkcEmauZ3m6Fm15CIy1QbE7nH20Eenk3cIxGXKXFaaQAZsJKrD07RjYSWARuxb8GNvDGRe5YOM9Gqh+k2I4Q7EYy36pVvkzuB9DWQ68M2+lpO/7Ettx18f8HN3sP3gxqCV2RRZOHPNqPy2hJyJlYn4zmor4Khk/TEhI39iMhXIk7u06iHDaesiF3/4u+x09UQaGcyhgyeIOd/O0N9ThQq853oeFRkV7ZanUxmZMBa9XSkpZoniiHgpffPudlriyK7vvmab9wWgr/GDtso/6BN/yZRbJl1mD+MutnR/zt+B5vI6dHW6vz9BrLTzHayX8bcbEwNuXuCWh6z6b4m9lrmXOzpmIddG7CS8ZFm2ot/WyH2ahZdurIJu66s0M9RSimlEMR/TIEr5XGyxMUAAAAASUVORK5CYII="
  searchChange$ = new Subject();
  searchText: string;

  constructor(private vm: EventViewModel, private route: ActivatedRoute, private modalService: NzModalService,
    private cd: ChangeDetectorRef
  ) {
    this.vm.cetQuotationsComponent = this
    this.searchChange$.pipe(debounceTime(200)).subscribe(name => {
      this.getData()
    });
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.vm.subscribeToVendorsRequests(this.vendorSubmissionResponseModel)

  }

  getData() {
    this.loading = true;
    this.allChecked = false;
    this.indeterminate = false;
    this.vm.getVendorSubmissions(1, 100, this.eventId, this.searchText, 'cetQuotationsComponent');
  }

  onSearch(event$: any): void {
    this.searchChange$.next(event$);
  }

  vendorRequestRecieved() {
    this.loading = false
    this.quotationList = this.vendorSubmissionResponseModel.value.results
    this.quotationList = this.quotationList.map(item => ({
      ...item,
      checked: false,
      disabled: false
    })
    );
  }


  onAllChecked(checked: boolean): void {
    this.allChecked = checked;
    this.quotationList.forEach(item => {
      if (!item.disabled) {
        item.checked = checked;
      }
    });
    this.indeterminate = false;
  }

  onItemChecked(item: any, checked: boolean): void {
    item.checked = checked;
    this.updateCheckStatus();
  }

  isSelectedAny(): boolean {
    const checkedItems = this.quotationList.filter(item => item.checked);
    // Condition 1: More than one item must be checked
    if (checkedItems.length >= 1) {
      return true;
    } else {
      return false;
    }
  }

  isComparable(): boolean {
    const checkedItems = this.quotationList.filter(item => item.checked);

    // console.log(checkedItems)

    // Condition 1: More than one item must be checked
    if (checkedItems.length <= 1) {
      return false;
    }

    // Condition 2: All checked items must have the same category
    // Get the category of the first checked item
    const firstCategory = checkedItems[0].quotation_request_vendor_details.quotation_request_details.outsourcing_form_details.category;

    // Check if all other checked items have the same category
    return checkedItems.every(item => item.quotation_request_vendor_details.quotation_request_details.outsourcing_form_details.category === firstCategory);
  }


  updateCheckStatus(): void {
    const total = this.quotationList.length;
    const checkedCount = this.quotationList.filter(item => item.checked).length;

    this.allChecked = checkedCount === total;
    this.indeterminate = checkedCount > 0 && checkedCount < total;
  }


  trackById(index: number, item: any): number {
    return item.id; // assuming id is unique
  }


  closeModal(event: MouseEvent, caller: string): void {
    // Stop event propagation to prevent any parent click handlers from interfering
    event.stopPropagation();
    if (this.compareQuatationModalRef && caller === 'compareQuotations') {
      this.compareQuatationModalRef.destroy(); // Destroy the modal instance
      this.compareQuatationModalRef = undefined; // Clear the reference
    }
    if (this.getClientPPTModalRef && caller === 'getClientPPT') {
      this.getClientPPTModalRef.destroy(); // Destroy the modal instance
      this.getClientPPTModalRef = undefined; // Clear the reference
    }
  }


  getClientPPT(): void {
    this.getClientPPTModalRef = this.modalService.create({
      nzTitle: this.getPPTModalModalTitle,
      nzContent: GenarateClientPptComponent,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'fullscreen-modal',
      nzStyle: {
        top: '0',
        padding: '0',
        margin: '0',
        bottom: '0',
        right: '0'
      },
      nzBodyStyle: {
        height: 'calc(100vh - 65px)',
        overflow: 'auto',
        background: '#fff',
        padding: '24px',
      },
      nzWidth: '100%',
      nzData: {
        selectedItems: this.quotationList.filter(item => item.checked),
        eventData: this.eventData
      }
    })
  }

  compareQuotations(): void {
    const selectedItems = this.quotationList.filter(item => item.checked);
    this.compareQuatationModalRef = this.modalService.create({
      nzTitle: this.compareQuatationModalTitle,
      nzContent: CompareQuotationsComponent,
      nzFooter: null,
      nzClosable: false,
      nzMaskClosable: false,
      nzClassName: 'fullscreen-modal',
      nzStyle: {
        top: '0',
        padding: '0',
        margin: '0',
        bottom: '0',
        right: '0'
      },
      nzBodyStyle: {
        height: 'calc(100vh - 65px)',
        overflow: 'auto',
        background: '#fff',
        padding: '24px',
      },
      nzWidth: '100%',
      nzData: {
        selectedItems: selectedItems,
        eventId: this.eventId
      }
    });

    this.compareQuatationModalRef.afterClose.subscribe(result => {
      // console.log('Modal closed with result:', result)
      this.getData();
    });
  }


  getOursouringTypeName(item: any) {
    const name = item?.quotation_request_vendor_details?.quotation_request_details?.outsourcing_event_request_details?.outsourcing_type_details?.name;
    return name ? name : 'No Name found'
  }

  getOursouringTypeImage(item: any) {
    const image = item?.quotation_request_vendor_details?.quotation_request_details?.outsourcing_event_request_details?.outsourcing_type_details?.image;
    return image ? image : ''
  }

  onVendorDetails(id: number) {
    this.rfqRef = this.modalService.create({
      nzTitle: 'Vendor Details',
      nzContent: CetVendorDetailsComponent,
      nzFooter: null,
      nzWidth: '90vw',
      nzStyle: {
        top: '40px',
      },
      nzData: {
        id: id
      }
    });



  }

  vendorSubmissionModalRef?: NzModalRef;
  viewVendorSubmission(item) {
    this.vendorSubmissionModalRef = this.modalService.create({
      nzTitle: 'Vendor Submission',
      nzContent: VendorSubmissionModalComponent,
      nzFooter: null,
      nzClassName: 'fullscreen-modal',
      nzStyle: {
        top: '0',
      },
      nzBodyStyle: {
        height: '100vh',
        overflow: 'auto',
        background: '#fff',
        padding: '24px',
      },
      nzWidth: '100%',
      nzData: {
        eventId: this.eventId,
        submissionId: item.id
      }
    });

    this.vendorSubmissionModalRef.afterClose.subscribe(result => {
      // if (result === true) {
      this.getData();
      // }
    });
  }


  formatIdToFourDigits(id: number): string {
    const str = 'QT'
    return id ? str + id.toString().padStart(4, '0') : '';
  }

}
